import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import pathfinder from '@fiverr-private/pathfinder';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import { BREAKPOINTS } from '../../../constants';

import styles from './index.module.scss';

const T_PREFIX = 'experts.vetted_business_banner';

/** @type {import('./index').BusinessVettedFreelancerBanner} */
export const BusinessVettedFreelancerBanner = ({ className, source }) => {
    const isLG = useMediaQuery({ minWidth: BREAKPOINTS.LG, maxWidth: BREAKPOINTS.XL });
    const url = pathfinder('business_landing_page', null, { query: { source } });

    return (
        <div className={classnames(className, styles.exploreBusiness, 'flex flex-items-center flex-between')}>
            <div className="m-r-12">
                <div className="text-bold tbody-4 co-text-darkest m-b-4">
                    <I18n k={`${T_PREFIX}.title_pro`} />
                </div>
                <div>
                    <I18n k={`${T_PREFIX}.sub_title`} />
                </div>
            </div>
            <div>
                <Button href={url} target="_blank" color={Button.COLORS.BLACK} fill={Button.FILLS.GHOST}>
                    <I18n k={isLG ? `${T_PREFIX}.button_short` : `${T_PREFIX}.button_pro`} />
                </Button>
            </div>
        </div>
    );
};

BusinessVettedFreelancerBanner.propTypes = {
    className: PropTypes.string,
    source: PropTypes.string,
};
